// extracted by mini-css-extract-plugin
export default {"cls1":"i2Bfuzyv6I13yy1pY3Jo","cls2":"L2H_KunlN_XrrDSKXnIk i2Bfuzyv6I13yy1pY3Jo"};